// extracted by mini-css-extract-plugin
export default {"modal":"style_modal__Pm3cF","card":"style_card__r74Sn","btnClose":"style_btnClose__kpbM7","title":"style_title__orTym","body":"style_body__EsxMY"};